








































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Resolve } from 'vue-di';
import Mm1Footer from './Mm1Footer.vue';
import LayoutModule from '~/store/layout';
import MedPrescribingInfo from '~/components/MedPrescribingInfo.vue';
import Mm1 from '~/pages/program-requirements/mm1.vue';
import PathModule from '~/store/path';
@Component<Footer>({
    components: {
        MedPrescribingInfo,
        Mm1Footer,
    },
})
export default class Footer extends Vue {
    @Resolve
    public layout!: LayoutModule;

    @Resolve
    public path!: PathModule;

    @Prop()
    public brkPoints!: object;
    @Prop({ default: false })
    public isFixed!: boolean;


    footerKey = 0;

    get phoneNumber() {
        return this.layout.program === 'pah' ? '1-866-228-3546' : '866-708-8987';
    }

    get isInlexzo(){
        return this.layout.program === 'inlexzo';
    }
    get isTremfyaStandard(){
        return this.layout.program === 'tremfyaStandard';
    }
    get isTremfya(){
        return this.layout.program === 'tremfya';
    }
    get isSimponi(){
        return this.layout.program === 'simponi';
    }
    get isStelaraStandard(){
        return this.layout.program === 'stelaraStandard';

    }
    get isSimponiAria(){
        return  this.layout.program === 'simponiAria';
    }
    get isRybrevant(){
        return this.layout.program === 'rybrevant';
    }
    get isMm1(){
        return this.layout.program === 'mm1';
    }
    get isImaavy(){
        return this.layout.program === 'imaavy';
    }
    get isIcotyde(){
        return this.layout.program === 'icotyde';
    }

    @Watch('layout.program', { deep: true })
    public watchLayoutProgramName() {
        this.footerKey += 1;
    }

    get showMedPrescLink() {
        const rebate = this.$route.path.includes('rebate');
        const card = this.$route.path.includes('card');
        const requirements = this.$route.path.includes('requirements');
        if (rebate || card || requirements) {
            return true;
        } else {
            return false;
        }
    }

    public get footerInfoLinkLocation() {
        return this.layout.configuration.footerInfoLinkLocation;
    }

    public get isTopOrBottomBar() {
        return ['top', 'bottom'].includes(this.footerInfoLinkLocation);
    }

    public get isLeftOrRightBar() {
        return ['left', 'right'].includes(this.footerInfoLinkLocation);
    }

    goToCookiePolicy() {
        this.$router.push({ path: '/cookie-policy' });
    }

    get getMonth(){
        if(this.isInlexzo || this.isMm1){
            return 'May';
        }
        // else if(this.isStelaraStandard || this.isSimponiAria || this.isTremfya || this.isTremfyaStandard || this.isSimponi){
        //     return 'November';
        // }
        // else if(this.isIcotyde){
            // return 'April';
        // }
        else{
         return 'April';
        }
    }

    // showCookieSettings() {
    //     // eslint-disable-next-line unicorn/prefer-query-selector
    //     const element = document.getElementById('onetrust-pc-btn-handler');
    //     if(element) {
    //         element.click();
    //     }
    // }
}
